/**
 * International phone support
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
var phoneInput = function(element, options) {

    var _defaults = {
         preferredCountries: ['us', 'gb', 'nl', 'de', 'fr', 'sp', 'cz', 'ca']
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});
    widget.input = element;
    widget.form = element.closest('form');

    widget._initialize();
    widget._bindEvents();

};

/**
 * Initialize plugin.
 * @param {jQUery Object} element
 *
 */
phoneInput.prototype._initialize = function() {
    var widget = this;
    widget.input.intlTelInput(widget.options);
    // Tell plugin that utils are available
    widget.input.intlTelInput("handleUtils");
};

/**
 * Bind form handler
 *
 */
phoneInput.prototype._bindEvents = function() {
    var widget = this;
    // Fill input with whole number
    widget.form.submit(function(e) {
        widget.input.val(widget.input.intlTelInput('getNumber'));
    });
};

module.exports = phoneInput;



// WEBPACK FOOTER //
// ./src/resources/js/phoneInput.js